import { useMemo } from 'react';

import { useHistory } from 'react-router-dom';

import { CampaignStatus, URLPaths } from 'models/enums';

import useQueryParams from './useQueryParams';

/**
 * A hook to get the statuses and the function to update them for the curations page.
 */
const useCurationsQueryParams = () => {
    const history = useHistory();
    const query = useQueryParams();
    const statusParam = query.get('status');
    const statuses: CampaignStatus[] = useMemo(
        () => (statusParam ? (statusParam.split(',') as CampaignStatus[]) : []),
        [statusParam]
    );

    const basePath = URLPaths.CURATIONS;

    const buildQueryParams = (newStatuses?: CampaignStatus[]) => {
        const params: string[] = [];
        const effectiveStatuses = newStatuses !== undefined ? newStatuses : statuses;

        if (effectiveStatuses.length > 0) {
            params.push(`status=${effectiveStatuses.join(',')}`);
        }

        return params.length > 0 ? `?${params.join('&')}` : '';
    };

    const changeViewParams = ({ newStatuses }: { newStatuses?: CampaignStatus[] } = {}) => {
        const queryParams = buildQueryParams(newStatuses);
        const path = `${basePath}${queryParams}`;
        history.push(path);
    };

    return { statuses, changeViewParams };
};

export default useCurationsQueryParams;
